import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * Quantity selector speziell für den Warenkorb.
 *
 * Verhalten:
 * Menge > 1  → Minus-Symbol
 * Menge = 1  → Papierkorb-Symbol
 * Klick bei 1 → Menge wird auf 0 gesetzt → Artikel wird entfernt
 *
 * @extends {QuantitySelectorComponent}
 */
export class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Cart verwendet das absolute Maximum.
   *
   * @returns {number | null}
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();

    return max;
  }

  /**
   * Aktualisiert Plus-/Minus-Status und das Remove-Icon.
   */
  updateButtonStates() {
    const { minusButton, plusButton } = this.refs;
    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    /*
     * Im Warenkorb soll Menge 0 erlaubt sein.
     *
     * Dadurch bleibt der Minus-Button bei Menge 1 aktiv.
     */
    minusButton.disabled = value <= min;

    plusButton.disabled =
      effectiveMax !== null &&
      value >= effectiveMax;

    /*
     * Bei Menge 1 zeigen wir statt Minus
     * den Papierkorb.
     */
    this.updateRemoveButtonState(value);
  }

  /**
   * Tauscht Minus-Symbol und Papierkorb-Symbol.
   *
   * @param {number} value
   */
  updateRemoveButtonState(value) {
    const { minusButton } = this.refs;

    if (!minusButton) return;

    const minusIcon =
      minusButton.querySelector(
        '.quantity-minus__minus'
      );

    const removeIcon =
      minusButton.querySelector(
        '.quantity-minus__remove'
      );

    if (!minusIcon || !removeIcon) return;

    const shouldShowRemove = value <= 1;

    minusIcon.hidden = shouldShowRemove;
    removeIcon.hidden = !shouldShowRemove;

    if (shouldShowRemove) {
      minusButton.setAttribute(
        'aria-label',
        'Produkt aus dem Warenkorb entfernen'
      );
    } else {
      minusButton.setAttribute(
        'aria-label',
        'Menge verringern'
      );
    }
  }
}


if (
  !customElements.get(
    'cart-quantity-selector-component'
  )
) {
  customElements.define(
    'cart-quantity-selector-component',
    CartQuantitySelectorComponent
  );
}